import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api.js";
import { TextField, Button, Banner, isValidEmail, COLORS as C } from "../components/UI.jsx";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [sent, setSent] = useState(false);

  const submit = async () => {
    setError(null);
    if (!email.trim()) { setError("Enter your email."); return; }
    if (!isValidEmail(email)) { setError("Enter a valid email address."); return; }
    setBusy(true);
    try {
      try { await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() }, { skipAuth: true }); } catch { /* intentional — don't leak email existence */ }
      setSent(true);
    } catch (e) {
      // Even on error, show success message — don't leak whether email exists
      setSent(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh", background: C.cream,
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 20, fontFamily: "-apple-system, system-ui, Inter, sans-serif",
    }}>
      <div style={{ width: "100%", maxWidth: 420 }}>
        <Link to="/" style={{ textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 10, marginBottom: 28 }}>
          <div style={{
            width: 32, height: 32, background: C.red, borderRadius: 8,
            display: "flex", alignItems: "center", justifyContent: "center",
            color: C.white, fontWeight: 800, fontSize: 16,
          }}>S</div>
          <div style={{ fontSize: 19, fontWeight: 800, color: C.navy }}>Shiftswift</div>
        </Link>

        <div style={{
          background: C.white, borderRadius: 14, padding: 32,
          border: `1px solid ${C.line}`, boxShadow: "0 8px 24px rgba(0,0,0,0.04)",
        }}>
          {sent ? (
            <>
              <h1 style={{ fontSize: 22, fontWeight: 800, color: C.navy, margin: 0 }}>Check your email</h1>
              <p style={{ fontSize: 14, color: C.text2, marginTop: 12, lineHeight: 1.6 }}>
                If an account exists for <strong>{email}</strong>, we've sent a password reset link to that address.
                It will be valid for 30 minutes.
              </p>
              <p style={{ fontSize: 13, color: C.text3, marginTop: 16, lineHeight: 1.6 }}>
                Don't see it? Check your spam folder, or try with a different email.
              </p>
              <div style={{ marginTop: 24 }}>
                <Button onClick={() => navigate("/login")}>Back to sign in</Button>
              </div>
            </>
          ) : (
            <>
              <h1 style={{ fontSize: 22, fontWeight: 800, color: C.navy, margin: 0 }}>Reset your password</h1>
              <p style={{ fontSize: 14, color: C.text3, marginTop: 8, marginBottom: 22 }}>
                Enter your email and we'll send a reset link.
              </p>

              {error && <Banner kind="error" onDismiss={() => setError(null)}>{error}</Banner>}

              <TextField
                label="Email" type="email" value={email} onChange={setEmail}
                placeholder="priya@business.com" autoFocus required
                onEnter={submit}
              />

              <Button onClick={submit} busy={busy}>
                {busy ? "Sending…" : "Send reset link"}
              </Button>

              <div style={{
                marginTop: 20, paddingTop: 16, borderTop: `1px solid ${C.line}`,
                fontSize: 13, color: C.text2, textAlign: "center",
              }}>
                Remember your password?{" "}
                <Link to="/login" style={{ color: C.red, fontWeight: 700, textDecoration: "none" }}>
                  Sign in
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
